import ToggleButtonGroup from './ToggleButtonGroup';

export { Props } from './ToggleButtonGroup';
export default ToggleButtonGroup;
